import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../Components/Table";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import { ExportarGestaoDeVisitaVendasController, GestaoDeVisitaVendasController } from "../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { IGestaoDeVisitasBody, IGestaoDeVisitasLst } from "../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import StorageManagerCapys from "../../../Tools/Storage";
import CardGestaoDeVisita from "./CardGestaoDeVisita";
import FiltroDeVisitas from "./FiltroDeVisitas";

export default function GestaoDeVisitas() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    
    const { PageFilter, setPage, filter, setPageFilter } =
        usePaginationFilter<IGestaoDeVisitasBody>({ page: 1 });

    const filterStorage = new StorageManagerCapys<IGestaoDeVisitasBody>(
        "FILTRO_GESTAO_VISITAS"
    );
    const { value: gestaoDeVisitasLst, loading: gestaoDeVisitasLstLoading } =
        useAsyncEffect(async () => {
            return GestaoDeVisitaVendasController(PageFilter.page, {
                ...PageFilter.filter,
                DT_FIM: PageFilter.filter?.DT_FIM ?? '',
                DT_INICIO: PageFilter.filter?.DT_INICIO ?? '',
                ID_EQUIPE_VENDAS: PageFilter.filter?.ID_EQUIPE_VENDAS ?? [],
                ID_PONTO_VENDA: PageFilter.filter?.ID_PONTO_VENDA ?? 0
            });
        }, [PageFilter]);

    const totalPages = gestaoDeVisitasLst?.NR_PAGINAS


    return (
        <div className="card card-custom p-10">
            <div className="w-100 d-flex justify-content-between align-items-center mb-8">
                <h4>Gestão de Visitas</h4>
                <button
                    className="btn btn-primary col-1"
                    onClick={() => {
                        setShow(true);
                        setModal({
                            Component: () => <CardGestaoDeVisita/>,
                            IconHeader: faCalendar,
                            headerComponent: "Evento",
                            size: "xl"
                        });
                    }}
                >
                    Criar Visita
                </button>
            </div>


            <OrSpinner
                spinner="capys"
                loading={false}
            >
                {
                    gestaoDeVisitasLst && (
                        <Table
                            defaultStyle={{
                                align: "center",
                                classes: "p-8",
                            }}
                            bordered={false}
                            striped
                            columns={AtendimentoVinculadoColumns}
                            data={gestaoDeVisitasLst.Visitas}
                            keyField="ID_CASO_VISITA"
                            classes="v-middle-cells"
                            onTableChange={(type, newState) => {
                                setPage(newState.page);
                            }}
                            remote={{ pagination: true }}
                            wrapperClasses="mw-100 custom-scroll"
                            totalPages={totalPages}
                            noDataIndication={
                                <div className="text-muted text-center">
                                    Esse atendimento não possui nenhuma
                                    Visita vinculada
                                </div>
                            }
                            loading={gestaoDeVisitasLstLoading}
                            noSearch
                        />
                    )
                }

                <FiltroDeVisitas
                    handleSubmit={(formData) => {
                        setPageFilter({
                            filter: formData,
                            page: 1,
                        });
                    }}
                    storageManager={filterStorage}
                    defaultFilter={filter} />
                <ExportExcel
                    baixarExcelController={async () =>
                        ExportarGestaoDeVisitaVendasController({
                            ...PageFilter.filter,
                            DT_FIM: PageFilter.filter?.DT_FIM ?? '',
                            DT_INICIO: PageFilter.filter?.DT_INICIO ?? '',
                            ID_EQUIPE_VENDAS: PageFilter.filter?.ID_EQUIPE_VENDAS ?? [],
                            ID_PONTO_VENDA: PageFilter.filter?.ID_PONTO_VENDA ?? 0
                        })
                    }
                    nomeArquivo={"Gestao_Visitas"}
                />

                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />
            </OrSpinner>
        </div>
    );
}
const AtendimentoVinculadoColumns: Array<
    ColumnDescription<IGestaoDeVisitasLst>
> = [

        {
            dataField: "DS_CLIENTE",
            text: "Cliente",
            formatter: (_, row) =>
                row.DS_CLIENTE ? (
                    <span>{row.DS_CLIENTE}</span>
                ) : (
                    <span>Não Possui Cliente</span>
                )
        },
        {
            dataField: "DS_EMAIL",
            text: "Email",
        },
        {
            dataField: "NR_TELEFONE",
            text: "Telefone",
            formatter: (_, row) =>
                row.NR_TELEFONE ? (
                    <span>{row.NR_TELEFONE}</span>
                ) : (
                    <span>Sem Número de Telefone</span>
                )
        },
        {
            dataField: "DS_ORIGEM",
            text: "Origem",
        },
        {
            dataField: "DS_CORRETOR",
            text: "Corretor",
        },
        {
            dataField: "DS_EQUIPE",
            text: "Equipe",
            formatter: (_, row) =>
                row.DS_EQUIPE ? (
                    <span>{row.DS_EQUIPE}</span>
                ) : (
                    <span>Sem Equipe de Venda</span>
                )
        },
        {
            dataField: "DS_PONTO_VENDA",
            text: "Ponto de Venda",
        },
        {
            dataField: "DS_TIPO_VISITA",
            text: "Tipo de Visita",
        },
        {
            dataField: "DT_DATA_VISITA",
            text: "Data",
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : "-"),
        },
        {

            dataField: "FL_EFETIVADA",
            text: "NV",
            formatter: (_, row) =>
                <button className="btn btn-danger" 
                title="Não Confirmar Visita"
                onClick={() => {
                    
                }}>
                    NV
                </button>

        },


    ]
